// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const deleteLinkedWorkItemPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Linked work item ID"),
});

export const deleteLinkedWorkItemHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Linked work item deleted successfully
 */
export const deleteLinkedWorkItem200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const deleteLinkedWorkItem401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Linked work item not found
 */
export const deleteLinkedWorkItem404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const deleteLinkedWorkItemMutationResponseSchema = z.lazy(() => deleteLinkedWorkItem200Schema);
